
















































import CommonBase from "../CommonBase";
import {Component, Inject, Prop} from "vue-property-decorator";
import Api from "./Api";
import SigninIcon from "../SigninIcon.vue";
import {InvalidPhoneNumber, PhoneNumber} from "../../modules/models";
import TopHdr from "./TopHdr.vue";
import Phoneinput from "@/components/phoneinput/Phoneinput.vue";
import {phoneCheck, phoneCheckedLocation} from "@/modules/LoginFlow";
import rd from "@/modules/vRoutedefs";
import AppRedirector from "@/components/shared/AppRedirector.vue";
import {hasIosAppInterface} from "@/modules/utils";
import {ignoreRedundantNavErr} from "@/router";

@Component({
    components: {
        "at-signin-icon": SigninIcon,
        "at-top-hdr": TopHdr,
        "at-phone-input": Phoneinput,
        "at-appredirector": AppRedirector,
    }
})
export default class FirstEntry extends CommonBase {
    @Inject()
    api!: Api;

    @Prop({default: ""})
    redir!: string;
    @Prop({default: null})
    phone!: string | null;

    working = false;
    phoneInvalidMsgs: string[] = [];
    errorMsg: string | null = null;

    pn: PhoneNumber | null = this.phone != null ? PhoneNumber.fromString(this.phone) : null;

    // Sends phone number to server to check what next step should be.
    // Possible replies:
    // 1: Phone registered (pending or confirmed). Display password input
    // 2: Not registered. Display signup
    async next() {
        this.working = true;
        try {
            const reply = await phoneCheck(this.pn, this.api);
            if(reply.errorMsg) {
                this.errorMsg = reply.errorMsg;
            } else if(reply.phoneInvalidMsg) {
                this.phoneInvalidMsgs = [reply.phoneInvalidMsg];
            } else if(this.pn != null) {
                ignoreRedundantNavErr(this.$router.push(phoneCheckedLocation(this.pn, reply.pendingCreated, reply.confirmedCreated, this.redir)));
            }
        } catch (err) {
            if(err instanceof InvalidPhoneNumber) {
                this.phoneInvalidMsgs = [`Ugyldig mobilnummer`];
            }
        } finally {
            this.working = false;
        }
    }

    get rd() {
        return rd;
    }

    autofocusPhone = false;

    async onShouldInstallApp(v: boolean) {
        if(!v) {
            this.autofocusPhone = true;
        }
    }

    get shouldShowAccountInfo() {
        // #AppleCompliance
        // Account init nav link must be hidden when in iOS app to comply with Apple guidelines/avoid app being blocked.
        return !hasIosAppInterface();
    }

}
